import { render, staticRenderFns } from "./ShopCarousel.vue?vue&type=template&id=6529e297&scoped=true"
import script from "./ShopCarousel.vue?vue&type=script&lang=js"
export * from "./ShopCarousel.vue?vue&type=script&lang=js"
import style0 from "./ShopCarousel.vue?vue&type=style&index=0&id=6529e297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6529e297",
  null
  
)

export default component.exports